import React, { useState } from "react";
import { Layout } from "../components/tag/Layout";
import { API } from "../lib/api";

export default function DueDiligence() {
  const [key, setKey] = useState(sessionStorage.getItem("tag_admin_key") || "");
  const [authed, setAuthed] = useState(!!sessionStorage.getItem("tag_admin_key"));

  const sign = (e) => {
    e.preventDefault();
    if (!key.trim()) return;
    sessionStorage.setItem("tag_admin_key", key.trim());
    setAuthed(true);
  };

  if (!authed) {
    return (
      <Layout title="DD Report | The Authority Gap" path="/dd">
        <section style={{ background: "#090909", padding: "80px 32px", textAlign: "center" }}>
          <form onSubmit={sign} className="tag-card" style={{ maxWidth: 420, margin: "0 auto", padding: 32 }}>
            <h2 className="tag-h2" style={{ marginBottom: 8 }}>Due Diligence Report</h2>
            <p style={{ color: "#888", fontSize: 13, marginBottom: 18 }}>Confidential. Admin key required.</p>
            <input
              data-testid="dd-admin-key"
              type="password"
              className="tag-input"
              placeholder="Admin key"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              style={{ marginBottom: 12 }}
              autoFocus
            />
            <button data-testid="dd-unlock" type="submit" className="btn-primary" style={{ width: "100%" }}>
              Unlock
            </button>
          </form>
        </section>
      </Layout>
    );
  }

  const pdfUrl = `${API}/dd/report.pdf?key=${encodeURIComponent(key)}`;

  return (
    <Layout title="TAG Due Diligence Audit | June 11, 2026" path="/dd">
      <section style={{ background: "#0a0a0a", borderBottom: "1px solid #1a1a1a", padding: "28px 32px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <div>
            <div style={{ color: "#FF6575", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>
              Confidential · Acquisition-grade
            </div>
            <h1 style={{ color: "#fff", fontSize: 22, fontWeight: 700, margin: 0 }}>TAG Due Diligence Audit — June 11, 2026</h1>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <a
              data-testid="dd-download"
              href={pdfUrl}
              download="TAG-Due-Diligence-Audit-6.11.26.pdf"
              className="btn-primary"
              style={{ fontSize: 12 }}
            >
              Download PDF
            </a>
            <button
              data-testid="dd-signout"
              type="button"
              onClick={() => { sessionStorage.removeItem("tag_admin_key"); setAuthed(false); setKey(""); }}
              className="btn-ghost"
              style={{ fontSize: 12 }}
            >
              Sign out
            </button>
          </div>
        </div>
      </section>

      <section style={{ background: "#1a1a1a", padding: "20px 0", textAlign: "center" }}>
        <iframe
          data-testid="dd-iframe"
          title="TAG Due Diligence Audit"
          src={pdfUrl}
          style={{ width: "min(1100px, 96%)", height: "min(1400px, 88vh)", border: "1px solid #2a2a2a", borderRadius: 6, background: "#fff" }}
        />
      </section>
    </Layout>
  );
}
